import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { BaseComponent } from '../../../components/BaseComponent';
import { Loader } from '../../../components/Loader';
import { logout } from '../../../modules/Api/actions';

const baseState = {};

/* eslint-disable react/prefer-stateless-function */
class LogoutComp extends BaseComponent {
  constructor(props) {
    super(props, { ...baseState });
  }

  componentDidMount() {
    this.props.logout();
  }

  render() {
    return <Loader onCard />;
  }
}

LogoutComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    logout: () => {
      dispatch(logout());
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const Logout = compose(
  withRouter,
  withConnect,
)(LogoutComp);
